import React from "react";
import ReactDOM from "react-dom/client";
import "@app/styles/App.css";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AuthProvider } from "@features/auth/model/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import { jam } from "@jam.dev/sdk";
import {
  getUserEmail,
  getUserId,
  getUserName,
  getUserPlanta,
  getUserRole,
} from "./utils/authStorage";

const ROLE_NAME_MAP = {
  1: "Administrador",
  2: "Inspector",
  3: "Supervisor",
  4: "Default",
  5: "Developer",
  6: "General",
  7: "Recursos Humanos",
  8: "Instalación",
};

const JAM_ENABLE_CUSTOM_DOMAIN =
  import.meta.env.VITE_JAM_ENABLE_CUSTOM_DOMAIN === "true";
const JAM_TEAM_ID = import.meta.env.VITE_JAM_TEAM_ID;
const JAM_ENABLE_METADATA = import.meta.env.VITE_JAM_ENABLE_METADATA !== "false";

const injectJamScript = (src) => {
  if (document.querySelector(`script[src="${src}"]`)) return;

  const script = document.createElement("script");
  script.type = "module";
  script.src = src;
  document.head.appendChild(script);
};

const initializeJamCustomDomain = () => {
  if (!JAM_ENABLE_CUSTOM_DOMAIN) return;

  if (!JAM_TEAM_ID) {
    console.warn(
      "[Jam] VITE_JAM_TEAM_ID no está definido. No se cargarán scripts de Jam.",
    );
    return;
  }

  let teamMeta = document.querySelector('meta[name="jam:team"]');
  if (!teamMeta) {
    teamMeta = document.createElement("meta");
    teamMeta.setAttribute("name", "jam:team");
    document.head.appendChild(teamMeta);
  }
  teamMeta.setAttribute("content", JAM_TEAM_ID);

  injectJamScript("https://js.jam.dev/recorder.js");
  injectJamScript("https://js.jam.dev/capture.js");
};

const initializeJamMetadata = () => {
  if (!JAM_ENABLE_METADATA) return;

  try {
    const roleId = getUserRole();
    jam.metadata(() => ({
      app: "WEBAPP-DARPHA",
      env: import.meta.env.MODE,
      userId: getUserId(),
      userName: getUserName() || null,
      userEmail: getUserEmail() || null,
      roleId,
      roleName: ROLE_NAME_MAP[roleId] || "Desconocido",
      planta: getUserPlanta(),
      currentPath: window.location.pathname,
    }));
  } catch (error) {
    console.warn("[Jam] No se pudo inicializar jam.metadata", error);
  }
};

// 🔇 Silenciar console.log en producción (mantener console.error y console.warn)
if (import.meta.env.PROD) {
  console.log = () => {};
}

// Manejador de actualizaciones del Service Worker
const handleServiceWorkerUpdate = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      console.log(
        "La aplicación se ha actualizado, recarga para ver los cambios.",
      );
    });
  }
};

handleServiceWorkerUpdate();
initializeJamCustomDomain();
initializeJamMetadata();

// Manejar errores de precarga de chunks de Vite (post-deploy con cache obsoleto)
window.addEventListener("vite:preloadError", (event) => {
  console.warn(
    "[vite:preloadError] Chunk precargado no disponible, recargando:",
    event.payload,
  );
  // Prevenir que el error se propague
  event.preventDefault();
  // Recargar la página para obtener los chunks actualizados
  window.location.reload();
});

// Registrar el Service Worker para notificaciones push
registerSW({
  onRegistered(registration) {
    console.log("Service Worker registrado:", registration);
  },
  onRegisterError(error) {
    console.error("Error al registrar el Service Worker:", error);
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const clientId =
  "424266454677-nffaqflg46g8ldvgvcm37l9us6esc5c3.apps.googleusercontent.com";

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
